'use client';

import animationData from '@/animations/use-case-omnichannel-macros.json';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { FC, useEffect, useRef } from 'react';

export interface UseCaseOmnichannelMacros {
  playing?: boolean;
}

const UseCaseAnimationMacros: FC<UseCaseOmnichannelMacros> = ({ playing }) => {
  const animationRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    if (!animationRef.current) return;

    if (playing) {
      animationRef.current.play();
    } else {
      animationRef.current.pause();
    }
  }, [playing]);

  return (
    <div className="w-full aspect-[844/844]">
      <Lottie animationData={animationData} autoplay={false} lottieRef={animationRef} />
    </div>
  );
};

export default UseCaseAnimationMacros;
